module.exports = __webpack_public_path__ + "vendors/createjs.min.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=vendors/createjs.min.js!./src/vendors/createjs/createjs.min.js
// module id = 2499
// module chunks = 0